import React, { useState } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';
import { Button, DatePicker, Form, message, Modal } from '@maxtropy/components';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;
type RangeValue = [Dayjs | null, Dayjs | null] | null;

interface RecalculateModalProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}

const RecalculateModal: React.FC<RecalculateModalProps> = ({ open, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [value, setValue] = useState<RangeValue>(null);
  const [dates, setDates] = useState<RangeValue>();

  const disabledDate = (current: Dayjs) => {
    if (!dates) return current > dayjs().endOf('day');
    const tooLate = dates[0] && current.diff(dates[0], 'months') >= 6;
    const tooEarly = dates[1] && dates[1].diff(current, 'months') >= 6;
    return !!tooEarly || !!tooLate || current > dayjs().endOf('day');
  };

  const reset = () => {
    form.resetFields();
    setValue(null);
    setDates(null);
  };

  const handleCancel = () => {
    reset();
    onCancel();
  };

  const handleSubmit = async () => {
    await form.validateFields();
    message.success('重计算完成');
    reset();
    onCancel();
    onSuccess();
  };

  return (
    <Modal
      title="重计算"
      forceRender
      open={open}
      afterClose={reset}
      onCancel={handleCancel}
      contentClassName="modal-form-content"
      footer={[
        <Button key="back" onClick={handleCancel}>
          取消
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          确定
        </Button>,
      ]}
    >
      <div className={styles.tip}>
        <ExclamationCircleOutlined />
        <span>重计算数值会覆盖现有数据</span>
      </div>
      <Form form={form}>
        <Form.Item label="选择时间" name="date" rules={[{ required: true, message: '请选择时间' }]}>
          <RangePicker
            value={value || dates}
            disabledDate={disabledDate}
            onCalendarChange={setDates}
            onChange={setValue}
            onOpenChange={nextOpen => setDates(nextOpen ? [null, null] : null)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RecalculateModal;
